import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import Layout from "../../Layouts";
import ProjectClosedIcon from "../../Assets/Icons/outline/archive-2.svg";
import Pagination from "../../Components/Pagination";
import ProjectTable from "./ProjectTable";
import AdminContext from "../../Services/Admin";
import Modal from "../../Components/Modal";
import DetailProjectCloseModal from "./DetailProjectCloseModal";
import InfoIcon from "../../Assets/Icons/outline/info-circle-black.svg";
import Select from "../../Components/Select";
import { generateYearOptions } from "../../utils/date";
import ApiWithAuth from "../../Config/Api/ApiWithAuth";

const selectPeriode = [
	{ value: "all", label: "Semua" },
	{ value: "1", label: "Term 1 (Jan - Jun)" },
	{ value: "2", label: "Term 2 (Jul - Des)" },
];

const selectYear = generateYearOptions();

const ProjectClosed = () => {
	const { loading, getAllMaster, addMaster } = useContext(AdminContext);
	const [data, setData] = useState({});
	const [pagination, setPagination] = useState(1);

	const { control, watch, setValue } = useForm({
		defaultValues: { year: "all", periode: "all" },
	});

	const year = watch("year");
	const periode = watch("periode");

	const [modal, setModal] = useState({
		show: false,
		id: "",
		type: "",
		data: {},
	});

	const getProjectsClosed = async () => {
		const res = await getAllMaster(
			`project/project-close?page=${pagination}&year=${year}&periode=${periode}`,
		);
		setData(res);
	};

	const handleShow = (id, type, data) => setModal({ show: true, id: id, type: type, data: data });

	const handleClose = () => {
		setModal({ show: false, id: "", type: "", data: {} });
	};

	const handleDelete = async (item) => {
		if (!window.confirm(`Delete closed project "${item?.name}"? This removes its points from the leaderboard.`)) return;
		const res = await addMaster(`project/close/delete/${item?.id}`, {});
		if (res?.success) {
			toast.success("Closed project deleted");
			getProjectsClosed();
		}
	};

	const handleDownload = () => {
		const suffix = year === "all" ? "All" : `${year}${periode === "1" || periode === "2" ? `_Term${periode}` : ""}`;
		ApiWithAuth.downloadDataWithAuth(
			`project/project-close/export`,
			{ year, periode },
			`Close_Project_${suffix}`,
			"xlsx",
		);
	};

	useEffect(() => {
		if (year === "all") setValue("periode", "all");
	}, [year, setValue]);

	useEffect(() => {
		getProjectsClosed();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pagination, year, periode]);

	return (
		<Layout title={"Close Project"} icon={ProjectClosedIcon}>
			<div className="flex items-center justify-between mb-4">
				<div className="flex items-center gap-6">
					<div className="flex items-center">
						<div className="font-semibold">Tahun :</div>
						<div className="w-40 ml-3">
							<Select control={control} id="year" data={selectYear} />
						</div>
					</div>
					<div className="flex items-center">
						<div className="font-semibold">Term :</div>
						<div className="w-52 ml-3">
							<Select control={control} id="periode" data={selectPeriode} disabled={year === "all"} />
						</div>
					</div>
				</div>
				<button
					type="button"
					onClick={handleDownload}
					className="py-2 px-5 rounded-xl bg-black text-white border border-black font-semibold hover:opacity-80"
				>
					Download Excel
				</button>
			</div>

			<div className="relative overflow-x-auto">
				<ProjectTable data={data?.data} from={data?.from} handleShow={handleShow} handleDelete={handleDelete} />
				<Pagination data={data} pagination={pagination} setPagination={setPagination} />
			</div>

			<Modal
				icon={InfoIcon}
				modal={modal}
				name={modal.type}
				handleClose={handleClose}
				submit={() => {}}
				loading={loading}
				width={"w-[800px]"}
				footer={
					<div className="flex items-center justify-end">
						<button
							type="button"
							onClick={handleClose}
							className="py-1 pt-2 w-[150px] rounded-xl bg-white border border-black font-semibold hover:bg-black hover:text-white"
						>
							Done
						</button>
					</div>
				}
			>
				<DetailProjectCloseModal
					data={modal?.data}
					handleClose={handleClose}
					refresh={() => getProjectsClosed()}
				/>
			</Modal>
		</Layout>
	);
};

export default ProjectClosed;
